import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

export interface Category {
    uuid: string;
    name: string;
    order?: number;
    iconUrl?: string | null;
    headerVideoUrl?: string | null;
    videoThumbnailUrl?: string | null;
}

export interface Directory {
    uuid: string;
    categoryUuid: string;
    categoryName: string;
    parentSubcategoryUuid?: string | null;
    directoryLevel?: string;
    order?: number;
    deleted_at?: string | null;
}

export interface CheckIn {
    uuid: string;
    category: "food_and_drink" | "shopping" | "culture" | "accommodation" | "location";
    categoryLabel: string;
    placeName: string;
    placeId: string;
    formattedAddress: string | null;
    latitude: number;
    longitude: number;
    provider: string;
    providerPlaceTypes: string[];
    placeImageReference: string | null;
    userCheckInsCount: number;
    hasUserCheckedIn: boolean;
}

export interface Post {
    uuid: string;
    subject?: string;
    message?: string | null;
    subcategoryUuid?: string | null;
    postType?: string;
    isFavourite?: boolean;
    image?: { imageUrl: string } | null;
    video?: { videoUrl: string; previewImageUrl?: string } | null;
    audio?: { audioUrl: string } | null;
    attachments?: Array<{ uuid: string; filename: string; s3Url: string }>;
    checkIn?: CheckIn | null;
}

export interface Home {
    categories: Category[];
    uncategorisedContent: Post[];
}

export interface CategoryContents {
    subcategories: Directory[];
    posts: Post[];
    recentlyAddedPostUuids: string[];
}

function headers(): { Authorization: string } {
    return { Authorization: `Bearer ${localStorage.getItem(UserKeys.TOKEN)}` };
}

export async function getViewerHome(signal: AbortSignal): Promise<Home> {
    const response = await axios.get<Home>(`${API_URL}/bodyAndMind/home`, { headers: headers(), signal });
    return response.data;
}

export async function getViewerCategory(uuid: string, signal: AbortSignal): Promise<CategoryContents> {
    const response = await axios.get<CategoryContents>(`${API_URL}/bodyAndMind/category/${encodeURIComponent(uuid)}`, {
        headers: headers(), signal
    });
    return response.data;
}

export async function updateCheckIn(postUuid: string, checked: boolean): Promise<CheckIn> {
    const url: string = `${API_URL}/bodyAndMind/contents/${encodeURIComponent(postUuid)}/check-in`;
    const response = checked
        ? await axios.put<{ checkIn: CheckIn }>(url, {}, { headers: headers() })
        : await axios.delete<{ checkIn: CheckIn }>(url, { headers: headers() });
    return response.data.checkIn;
}
